import { render, staticRenderFns } from "./ExtraModulesLanding.vue?vue&type=template&id=431bab69&scoped=true&"
import script from "./ExtraModulesLanding.vue?vue&type=script&lang=js&"
export * from "./ExtraModulesLanding.vue?vue&type=script&lang=js&"
import style0 from "./ExtraModulesLanding.vue?vue&type=style&index=0&id=431bab69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431bab69",
  null
  
)

export default component.exports